import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import SuiviFacturesService, { FacturesParams } from '../../../services/SuiviFacturesService';
import { SUIVI_FACTURES_AVANT_ECHEANCE } from './mutation-types';
import { SuiviFacturesAvantEcheance, SuiviFacturesAvantEcheanceActionTypes } from './action-types';
import { SuiviFacturesAvantEcheanceState } from './state';
import { SuiviFacture } from '@/models/SuiviFacture';
import { SUIVI_FACTURES_EN_RETARD } from '@/modules/SuiviFactures/store/modules/SuiviFacturesEnRetard/mutation-types';

export const actions: ActionTree<SuiviFacturesAvantEcheanceState, RootState> = {
    async [SuiviFacturesAvantEcheance.GET_SUIVI_FACTURES_AVANT_ECHEANCE](
        { commit }: SuiviFacturesAvantEcheanceActionTypes,
        payload: FacturesParams
    ) {
        commit(SUIVI_FACTURES_AVANT_ECHEANCE.SET_PAGE_AVANT_ECHEANCE, payload.page);
        commit(SUIVI_FACTURES_AVANT_ECHEANCE.SET_ERROR_AVANT_ECHEANCE, undefined);
        commit(SUIVI_FACTURES_AVANT_ECHEANCE.SET_IS_LOADING_AVANT_ECHEANCE, true);
        try {
            const response = await SuiviFacturesService.getSuiviFacturesAvantEcheance(payload);
            if (response.status === 200 && response.data !== undefined) {
                if (payload.page === 0) {
                    commit(SUIVI_FACTURES_AVANT_ECHEANCE.SET_ITEMS_AVANT_ECHEANCE, response.data.content);
                    commit(SUIVI_FACTURES_AVANT_ECHEANCE.SET_SCROLL, 0);
                    commit(SUIVI_FACTURES_AVANT_ECHEANCE.SET_NB_OF_PAGES_AVANT_ECHEANCE, response.data.totalPages);
                    commit(SUIVI_FACTURES_AVANT_ECHEANCE.SET_COUNT_AVANT_ECHEANCE, response.data.totalElements);
                } else {
                    commit(SUIVI_FACTURES_AVANT_ECHEANCE.ADD_ITEMS, response.data.content);
                }
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(SUIVI_FACTURES_AVANT_ECHEANCE.SET_IS_LOADING_AVANT_ECHEANCE, false);
        } catch (error) {
            commit(SUIVI_FACTURES_AVANT_ECHEANCE.SET_IS_LOADING_AVANT_ECHEANCE, false);
            commit(SUIVI_FACTURES_AVANT_ECHEANCE.SET_ERROR_AVANT_ECHEANCE, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
    async [SuiviFacturesAvantEcheance.GET_FACTURES_AVANT_ECHEANCE_PDF](
        { commit }: SuiviFacturesAvantEcheanceActionTypes,
        factureToDownload: SuiviFacture
    ) {
        try {
            const response = await SuiviFacturesService.getFacturePdf(factureToDownload.numeroFacture, factureToDownload.societeId);
            if (response.status === 200 && response.data !== undefined) {
                const file = new Blob([response.data], { type: 'application/pdf' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(file);
                link.download = `${factureToDownload.numeroFacture}.pdf`;
                link.click();
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(SUIVI_FACTURES_EN_RETARD.SET_IS_LOADING_EN_RETARD, false);
        } catch (error) {
            commit(SUIVI_FACTURES_EN_RETARD.SET_IS_LOADING_EN_RETARD, false);
            commit(SUIVI_FACTURES_EN_RETARD.SET_ERROR_EN_RETARD, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
};
